import { render, staticRenderFns } from "./all.vue?vue&type=template&id=531f4387&scoped=true&"
import script from "./all.vue?vue&type=script&lang=js&"
export * from "./all.vue?vue&type=script&lang=js&"
import style0 from "./all.vue?vue&type=style&index=0&id=531f4387&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f4387",
  null
  
)

export default component.exports